import { render, staticRenderFns } from "./PlayerVideo.vue?vue&type=template&id=393bd072&"
import script from "./PlayerVideo.vue?vue&type=script&lang=js&"
export * from "./PlayerVideo.vue?vue&type=script&lang=js&"
import style0 from "./PlayerVideo.vue?vue&type=style&index=0&id=393bd072&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports